import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ResumeSessionRowType } from 'pages/resume/ResumeRow/ResumeSessionRowType'
import { isBefore, parseISO } from 'date-fns'

const initialState: ResumeSessionData = {
  rows: [],
  page: 1,
  perPage: 20,
  filter: {},
}

export const resumeSessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setRows: (state, { payload }: PayloadAction<ResumeSessionData['rows']>) => {
      state.rows = payload
      const filteredRows = filterResumeRows(payload, state.filter)
      const lastPage = Math.max(
        1,
        Math.ceil(filteredRows.length / state.perPage)
      )
      state.page = Math.min(state.page, lastPage)
    },
    setPage: (state, { payload }: PayloadAction<ResumeSessionData['page']>) => {
      state.page = payload
    },
    setFilterText: (
      state,
      { payload }: PayloadAction<ResumeSessionFilter['text']>
    ) => {
      state.filter.text = payload
    },
    setFilterStartDate: (
      state,
      { payload }: PayloadAction<ResumeSessionFilter['startDate']>
    ) => {
      state.filter.startDate = payload
    },
    setFilterEndDate: (
      state,
      { payload }: PayloadAction<ResumeSessionFilter['endDate']>
    ) => {
      state.filter.endDate = payload
    },
  },
})

export const {
  setRows,
  setPage,
  setFilterText,
  setFilterStartDate,
  setFilterEndDate,
} = resumeSessionSlice.actions

export interface ResumeSessionData {
  rows: ResumeSessionRowType[]
  page: number
  perPage: number
  filter: ResumeSessionFilter
}

export interface ResumeSessionFilter {
  text?: string
  startDate?: string
  endDate?: string
}

export const filterResumeRows = (
  rows: ResumeSessionRowType[],
  filter: ResumeSessionFilter
) =>
  rows.filter(row => {
    const matchesText =
      !filter.text ||
      row.guideName.toLowerCase().includes(filter.text.toLowerCase())
    const matchesStartDate =
      !filter.startDate ||
      !isBefore(parseISO(row.startDate), parseISO(filter.startDate))
    return matchesText && matchesStartDate
  })
